import { Link } from "react-router-dom";

interface SideNavigationItemProps {
    title?: string;
    path?: string;
    children?:React.ReactNode;
}

export const SideNavigationItem: React.FC<SideNavigationItemProps> = ({ title, path, children }) => {
    return <Link to={path ?? '#'} style={{
        margin: 8,
        color: 'black'
    }}>
        <center>{children}</center>
        <center style={{fontSize: 18}}>{title}</center>
    </Link>
}
